export const formatNumber = (number: number, separator = ' '): string =>
  String(number).replace(/\B(?=(\d{3})+(?!\d))/g, separator);

export const numberToNorwayNumberHour = (hoursString: any, isTwoDecimal: boolean = false): string => {
  if (hoursString === "" || hoursString === "0,0" || hoursString == null) {
    return hoursString;
  }

  if (hoursString === ",") {
    return "0,0";
  }

  let number = '';
  if (hoursString.toString().includes(",")) {
    number = hoursString.toString().replace(" ", "").replace(",", ".");
  } else {
    number = hoursString.toString();
  }

  number = Number(number).toString().replace(".", ",");
  return number.includes(",") ? number : (isTwoDecimal ? number + ',00' : number + ',0');
};
